export default (value: string) => {
    return value;
} 